import { AppAlert } from '@components/antd';
import { AppModal } from '@components/form/Modal';
import { Modal } from 'antd';
import { RiPhoneFill } from 'react-icons/ri';
import { useTranslation } from 'react-i18next';
import { useSwitchCallBanner } from './hooks/use-switch-call-banner';

export const SwitchCallBanner = () => {
  const { loading, switchModal, handleSwitchCall } = useSwitchCallBanner();
  const { t } = useTranslation();
  return (
    <>
      <AppAlert
        showIcon
        type="success"
        icon={<RiPhoneFill size={20} />}
        message={
          <p className="text-sm">
            {t('youre_currently_on_an_active_call_on_another_device')}{' '}
            <a className="font-semibold  underline! underline-offset-2!" onClick={switchModal.handleOpen}>
              {t('switch_call_to_this_device')}
            </a>
          </p>
        }
      />

      <Modal
        classNames={{ content: '!max-w-[420px]' }}
        centered
        open={switchModal.open}
        onCancel={switchModal.handleClose}
        title={
          <AppModal.Header>
            <AppModal.Title>{t('switch_call_to_this_device')}</AppModal.Title>
          </AppModal.Header>
        }
        footer={
          <AppModal.Footer>
            <AppModal.Button className="w-full" onClick={switchModal.handleClose}>
              Cancel
            </AppModal.Button>
            <AppModal.Button className="w-full" type="primary" onClick={handleSwitchCall} loading={loading}>
              Switch
            </AppModal.Button>
          </AppModal.Footer>
        }
      >
        <AppModal.Body>
          <p>{t('are_you_sure_you_want_to_switch_the_call_on_your_current_device_will_be_put_on_hold')}</p>
        </AppModal.Body>
      </Modal>
    </>
  );
};
